import type {
  ProcessedBetEntry,
  ProcessedEntries,
} from "@/hooks/firestore/betting/useEntries";

import { usePermission } from "@/features/auth/hooks/usePermission";
import { isBetEntry } from "../util/type-guards";

const useEligibleEntries = (entries: ProcessedEntries) => {
  // Check user has permission
  const cashoutPermission = usePermission("cashoutBet");
  const hasCashoutPermission = cashoutPermission === "GRANTED";

  if (!hasCashoutPermission) {
    return [];
  }

  // Filter entries that are cashout eligible
  const cashoutEligibleEntries = entries.filter(
    (entry): entry is ProcessedBetEntry => {
      return isBetEntry(entry) && !!entry.data.eligibleForPotentialCashout;
    },
  );

  return cashoutEligibleEntries.map((entry) => entry.referenceId);
};

export { useEligibleEntries };
